/**
 * @module overallOverview reporting
 *
 * Contains all data needed to render overview tab for survey reporting.
 *
 * DEPRECATED: This will be changed to use the new reporting state as per
 * `/docs/architecture/reporting_state.md`. Renamed to `legacyOverview` to
 * continue working while new structure is being developed.
 */
import { createReducer } from '@reduxjs/toolkit';
import { surveyReportingActions } from '../actions/survey_reporting.actions';
import { metaActions } from '../actions/meta.actions';
import { accountActions } from '../actions/account.actions';

const defaultState = {
  factors: [],
  questions: [],
  suggestedContent: [],
  highlights: {},
  permissionLabel: '',
};

const reset = () => defaultState;

const legacyOverview = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(surveyReportingActions.resetReportingState, reset);
});

export default legacyOverview;
